@if(dialog$ | async; as dialog) {
    <div class="modal-header modal-header--import flex-column">
        <div class="modal-title">Import - Fundraisers</div>
        <div class="modal-subtitle mt-2">Import Fundraisers from an excel file (Download 
            <a (click)="downloadExcelTemplate()" class="template">template</a>) 
            <a class="template" (click)="onToggleReadMore()">{{readmore ? 'hide more': 'read more'}}</a>
        </div>
        <button type="button" class="cursor-pointer" class="close close--paybee position-absolute" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
            <span class="cursor-pointer" aria-hidden="true">×</span>
        </button>
        @if(readmore) {
            <div class="readmore mt-2">
                <div class="mb-3">Support File Format: Excel with header row</div>
                <div>
                    <div class="headline-7--temporary mb-2">Fundraisers Sheet</div>
                    <div class="modal-subtitle mb-2">Fill for all Fundraisers</div>
                    <table width="750" border="2" cellpadding="5">
                        <thead>
                            <tr>
                                <td><b>Column Name</b></td>
                                <td><b>Required</b></td>
                                <td><b>Description</b></td>
                                <td><b>Note</b></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>required</td>
                                <td>Name</td>
                                <td>Full Name (16 characters max)</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>required</td>
                                <td>Email</td>
                                <td>Full Email </td>
                            </tr>
                            <tr>
                                <td>Goal</td>
                                <td>required</td>
                                <td>Goal</td>
                                <td>Min value 1</td>
                            </tr>
                            
                            @if(teams.length > 0) {
                                <tr>
                                    <td>Team Name</td>
                                    <td>required</td>
                                    <td>Team Name</td>
                                    <td>Full Name of Team (16 characters max)</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        }
    </div>
    @if(!closeButton) {
        <div class="modal-body">
            <app-champions-import-xlsx
                [schema]="schema"
                [import]="import"
                [champions]="champions"
                [teams]="teams"
                (onChange)="onChangeData($event)"
            ></app-champions-import-xlsx>

            <div class="d-flex align-items-center">
                <app-mdb-switch label="Send fundraiser creation emails to all" [formControl]="sendNotification"></app-mdb-switch>
                <div class="d-flex align-items-center ml-2 h-100">
                    <app-text-popover
                        placement="right"
                        type="content"                       
                        title=""
                        text="Let champions know that their fundraisers have been created via email"
                    >
                    </app-text-popover>
                </div>
            </div>
        </div>
    }
    @if(closeButton) {
        <div class="modal-body">
            <div class="d-flex flex-column align-items-center my-5">
                <div>Successfully loaded {{champions.length}} items.</div>
                <div>New items will appear at the bottom.</div>
            </div>
        </div>
    }
    
    <div class="modal-footer modal-footer--import">
        <div class="d-flex justify-content-between w-100">
            <div class="col-8 d-flex align-items-center">
                @if(import.value) {
                    @if(champions.length === 1) {
                        <div class="modal__found">{{champions.length}} item found</div>
                    }
                    @else {
                        <div class="modal__found">{{champions.length}} items found</div>
                    }
                }
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-6 px-2">
                        @if(confirm) {
                            <button
                                (click)="onConfirm(dialog)" [disabled]="confirmDisabled"
                                type="button" class="btn btn--paybee btn--black btn--md text-center w-100">
                                Confirm
                            </button>
                        }
                        @if(closeButton) {
                            <button
                                (click)="onClose(dialog)" type="button" class="btn btn--paybee btn--black btn--md text-center w-100">
                                Close
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
